import { Ticket } from 'api';
import { DataGridColumn } from 'ui';

export const columns: DataGridColumn<Ticket>[] = [
  {
    columnSize: 'large',
    field: 'summary',
    filterable: true,
    headerName: 'Summary',
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'medium',
    field: 'status',
    filterable: false,
    headerName: 'Status',
    sortable: false,
    type: 'string',
  },
  {
    field: 'team',
    filterable: true,
    headerName: 'Team',
    sortable: false,
    type: 'string',
  },
  {
    field: 'request_category',
    filterable: false,
    headerName: 'Category',
    sortable: false,
    type: 'string',
  },
];
